import { Link } from "react-router-dom";
import { Button, Typography } from "@mui/material";
import { login, setRedirect } from "../../app/auth";
import { LoginReason } from "../../app/backendTypes";

function LoginRedirect(props: { reason: LoginReason | null }) {
  if (props.reason == null) {
    return (
      <>
        <Typography variant="h3">Welcome to MyTools</Typography>
        <br />
        <Button
          variant="outlined"
          onClick={() => {
            setRedirect(window.location.pathname + window.location.search);
            login();
          }}
        >
          Login with Visma Connect
        </Button>
      </>
    );
  }

  let reason;

  switch (props.reason) {
    case LoginReason.Inactive: {
      reason = "Account is inactive";
      break;
    }

    case LoginReason.ExternalConsultant: {
      reason = "Account is an external consultant";
      break;
    }

    case LoginReason.NonVismaInfrastructure: {
      reason = "Account is not in Visma infrastructure";
      break;
    }

    case LoginReason.NoVomData: {
      reason = "Account has no VOM data";
      break;
    }
  }

  const content = (
    <>
      <Typography variant="h6">
        It seems that you are not allowed to be here
      </Typography>
      <br />
      <Typography variant="subtitle2">Reason: {reason}</Typography>
    </>
  );

  return (
    <>
      {content}
      <br />
      <Button variant="outlined" component={Link} to="/logout">
        Logout
      </Button>
    </>
  );
}

export default LoginRedirect;